
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * RightsMode enum
 */
class RightsMode {
  /**
   * Initialize enum with a given value
   * @param {RightsMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof RightsMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!RightsMode}
   * @param {!RightsMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof RightsMode)) {
      throw new TypeError('Instance of RightsMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!RightsMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!RightsMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === RightsMode.NONE.value) {
      return 'NONE'
    }
    if (this.value === RightsMode.VIEW_ONLY.value) {
      return 'VIEW_ONLY'
    }
    if (this.value === RightsMode.EDIT_ONLY.value) {
      return 'EDIT_ONLY'
    }
    if (this.value === RightsMode.CUSTOM.value) {
      return 'CUSTOM'
    }
    if (this.value === RightsMode.FULL.value) {
      return 'FULL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!RightsMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!RightsMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!RightsMode} Created enum
   */
  static fromObject (other) {
    return new RightsMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
RightsMode.NONE = new RightsMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
RightsMode.VIEW_ONLY = new RightsMode(0 + 1)
// noinspection PointlessArithmeticExpressionJS
RightsMode.EDIT_ONLY = new RightsMode(0 + 2)
// noinspection PointlessArithmeticExpressionJS
RightsMode.CUSTOM = new RightsMode(0 + 3)
// noinspection PointlessArithmeticExpressionJS
RightsMode.FULL = new RightsMode(0 + 4)

export { RightsMode };

/**
 * Fast Binary Encoding RightsMode field model
 */
class FieldModelRightsMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelRightsMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelRightsMode}
   * @param {RightsMode=} defaults Default value, defaults is new RightsMode()
   * @returns {!RightsMode} Result value
   */
  get (defaults = new RightsMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new RightsMode(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelRightsMode}
   * @param {!RightsMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelRightsMode };
